import { Parser } from '~/api';
import { Egg } from '~/api/models';
import RequestService from './request';

interface ListRequest extends PaginatableRequest {
    search?: string;
    category?: string;
    source_key?: string;
}

interface ImportRequest {
    source_key: string;
    source_id: string;
    tags?: string[];
}

export interface CatalogFacets {
    categories: string[];
    sources: { key: string; label: string }[];
}

class EggCatalogService {
    list(req: ListRequest = {}, extraData: Record<string, unknown> = {}): Promise<ListResponse> {
        return RequestService.get('/egg-catalog', { ...req, ...extraData }).then(Parser.parse);
    }

    facets(): Promise<CatalogFacets> {
        return RequestService.get('/egg-catalog/facets');
    }

    refresh(): Promise<void> {
        return RequestService.post('/egg-catalog/refresh');
    }

    import(data: ImportRequest): Promise<Egg> {
        return RequestService.post('/egg-catalog/import?include=tags', data).then(Parser.parse);
    }
}

export default new EggCatalogService();
